import styled from "styled-components";

export const StyledTableContainer = styled.div`
  max-width: 100vw;
  color: black;
  align-self: flex-start;
  overflow-x: auto; 
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const StyledTableHead = styled.thead`
  background-color: #333;
  color: white;
`;

export const StyledTableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

export const StyledTableHeaderCell = styled.th`
  padding: 10px;
  @media (max-width: 768px) {
    font-size: 14px; /* Adjust font size for smaller screens */
  }
`;

export const StyledTableCell = styled.td`
  padding: 10px;
  @media (max-width: 768px) {
    font-size: 14px; /* Adjust font size for smaller screens */
  }
`;